import { Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import styled from "styled-components"

export const StyledBigNumber = styled(Typography.BigNumber)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.main};
`
